import { Breadcrumbs, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import { Link, withRouter,useLocation } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
    div: {
        backgroundColor: "#fff",
        padding: '15px 13px',
        margin: '-5px -10px 10px -10px'
    },
}));

function FeeScheduleDroppable({  breadcrumbItems, currentDirectory, selectedFeeScheduleIds, handleRefresh,
    actions: { moveDirectoryOrFeeSchedule, resetSelectedFeeSchedule } }) {
    const classes = useStyles();
    const location = useLocation();
    const currentLocation = location.pathname;
    const isFeeScheduleEditPage = currentLocation.indexOf('/feeschedules/edit') !== -1 || currentLocation.indexOf('/global-feeschedules/edit') !== -1;
    const isFeeScheduleDetailsPage = currentLocation.indexOf('/feeschedules/view') !== -1 || currentLocation.indexOf('/global-feeschedules/view') !== -1;
    const mode=currentLocation.includes('new')?'Create':'Edit'
    const isGlobal =  currentLocation.indexOf('global-feeschedules') !== -1;
    const pathPrefix = isGlobal ? "/cms/global-feeschedules" : "/cms/feeschedules";

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedItems = JSON.parse(e.dataTransfer.getData('items'));
        onDrop(droppedItems, e.target.id);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const onDrop = (droppedItems, folderId) => {
        const destinationDirectoryId = folderId.split('folder-')[1];
        let feeScheduleIds = [];
        let directoryIds = [];
        if (selectedFeeScheduleIds.length > 0) {
            for (let item of selectedFeeScheduleIds) {
                const splittedItem = item.split('-');
                if (splittedItem[0] === 'feeschedule') {
                    feeScheduleIds.push(splittedItem[1]);
                } else if (splittedItem[0] === 'folder') {
                    directoryIds.push(splittedItem[1])
                }
            }
        } else {
            for (let item of droppedItems) {
                const splittedItem = item.split('-');
                if (splittedItem[0] === 'feeschedule') {
                    feeScheduleIds.push(splittedItem[1]);
                } else if (splittedItem[0] === 'folder') {
                    directoryIds.push(splittedItem[1])
                }
            }
        }
        const payload = {
            feeScheduleIds,
            directoryIds,
            destinationDirectoryId: destinationDirectoryId === 'root' ? undefined : destinationDirectoryId
        }
        moveDirectoryOrFeeSchedule(payload, handleCallback);
    };

    const handleCallback = () => {
        handleRefresh();
        resetSelectedFeeSchedule();
    }

    const getBreadCrumbsItems = () => { 
        if(!isFeeScheduleEditPage && !isFeeScheduleDetailsPage) return breadcrumbItems ;
        else if(!currentDirectory) return []
        else return [...breadcrumbItems,{id:currentDirectory?.parentId,name:currentDirectory?.parentName}]
    }

    return (
        <>
            <div className={`${classes.div} bread-crumb`}>
                <Breadcrumbs separator=">" aria-label="breadcrumb">
                    <Link id={`folder-root`} onDragOver={handleDragOver} onDrop={handleDrop} className='breadcrumb-link' to={`${pathPrefix}/root`} color="inherit" >
                       {isGlobal ? "Global Fee Schedules" : "Fee Schedules"}
                    </Link>
                    {getBreadCrumbsItems().map((breadcrumb, index) =>
                        <Link id={`folder-${breadcrumb.id}`} onDragOver={handleDragOver} onDrop={handleDrop} className='breadcrumb-link' to={`${pathPrefix}/${breadcrumb.id}`} key={index.toString()} color="inherit" >
                            {breadcrumb.name}
                        </Link>
                    )}
                    {!isFeeScheduleEditPage && currentDirectory && !isFeeScheduleDetailsPage &&
                        <Typography className='breadcrumb-active' >{currentDirectory.parentName}</Typography>
                    }

                    {isFeeScheduleEditPage &&
                        <Typography className='breadcrumb-active' >{`${mode} Fee Schedule`}</Typography>
                    }

                    {isFeeScheduleDetailsPage && (
                        <Typography className="breadcrumb-active">
                            {isGlobal ? "Global Fee Schedule Details" : "FeeSchedule Details"}
                        </Typography>
                    )}
                </Breadcrumbs>
            </div>
        </>
    )
}

export default withRouter(FeeScheduleDroppable as any)